/**
 * @description Axios HTTP Handler Utility
 * @author Fahid Mohammad
 */
// TODO: Need to handle all types of request in case of post
//       Need to clear unwanted consolses once the final development is over
//       Code refactor is needed, need to find a better solution to handle request and response with a rejection
import axios from 'axios'
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import { auth_url, oh_url } from '../../config/endpoints'
import router from '../router'
Vue.use(VueLocalStorage)

let http = axios.create({
  baseURL: oh_url,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  },
  withCredentials: false
})

const refreshHttp = axios.create()
let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

const clearAuthData = () => {
  Vue.localStorage.remove('token')
  Vue.localStorage.remove('refresh_token')
  Vue.localStorage.remove('userdata')
  Vue.localStorage.remove('utid')
}

http.interceptors.request.use(
  config => {
    const token = Vue.localStorage.get('token')
    if (token) {
      config.headers['Authorization'] = token
    }
    config.headers['platform'] = 'mac'
    return config
  },
  error => Promise.reject(error)
)

http.interceptors.response.use(
  async response => {
    if (response.data?.status === 2000) {
      const originalRequest = response.config
      
      if (originalRequest._retry) {
        clearAuthData()
        router.push({ path: '/' }).catch(() => {})
        return response
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject })
        }).then(token => {
          originalRequest.headers['Authorization'] = token
          return http(originalRequest)
        }).catch(err => {
          clearAuthData()
          router.push({ path: '/' }).catch(() => {})
          return Promise.reject(err)
        })
      }

      // Claim the lock immediately so other 2000 responses queue instead of calling refresh again
      isRefreshing = true
      originalRequest._retry = true

      const refreshToken = Vue.localStorage.get('refresh_token')
      if (!refreshToken) {
        isRefreshing = false
        processQueue(new Error('No refresh token'), null)
        clearAuthData()
        router.push({ path: '/' }).catch(() => {})
        return response
      }

      try {
        console.log('Calling refresh token API')
        const refreshResponse = await refreshHttp.post(`${auth_url}pro/refresh-token`, {}, {
          headers: { 
            'Authorization': refreshToken,
            'Content-Type': 'application/json'
          }
        })

        console.log('Refresh response:', refreshResponse.data)

        // If refresh-token API itself returns 2000, treat it as invalid session and redirect
        if (refreshResponse.data.status === 2000) {
          try {
            const currentRoute = router.currentRoute
            if (
              currentRoute &&
              currentRoute.query &&
              currentRoute.query.refreshToken &&
              typeof window !== 'undefined' &&
              window.ReactNativeWebView
            ) {
              window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'end' }))
            }
          } catch (_) {
            // Ignore postMessage errors so refresh flow is not affected
          }
        }

        if (refreshResponse.data.status === 1000) {
          const newToken = refreshResponse.data.token
          const newRefreshToken = refreshResponse.data.refresh_token
          
          console.log('Token refreshed successfully')
          Vue.localStorage.set('token', newToken, 60 * 60 * 2 + 55)
          if (newRefreshToken) {
            Vue.localStorage.set('refresh_token', newRefreshToken)
          }
          
          http.defaults.headers.common['Authorization'] = newToken
          originalRequest.headers['Authorization'] = newToken
          processQueue(null, newToken)
          isRefreshing = false
          // Notify host only when refresh-token API was actually called (and succeeded)
          
          return http(originalRequest)
        } else {
          throw new Error('Refresh failed')
        }
      } catch (refreshError) {
        console.error('Refresh error:', refreshError)
        isRefreshing = false
        processQueue(refreshError, null)
        clearAuthData()
        router.push({ path: '/' }).catch(() => {})
        return response
      }
    }
    return response
  },
  error => Promise.reject(error)
)

export default http
    